export function getIds() {
  const uniqueID = new Date().getTime() + Math.floor(Math.random() * 1000)
  const externalID = uniqueID * 2

  return {
    externalID,
    uniqueID,
  }
}
